<template>

	<div :class="[{'icon':true, byHeight:iconInfo.byHeight},classes]" :title="title" @click="clicked">
		<img :src="iconInfo.src" class="svg" v-if="iconInfo.type==='img'" :style="{ color: color, fill: color }" />
		<font-awesome-icon :icon="iconInfo.icon" v-if="iconInfo.type==='fa'" :style="{ color: color }" />
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :viewBox="iconInfo.viewBox" xml:space="preserve" v-if="iconInfo.type==='svg'" v-html="iconInfo.src" />
		<span :class="{'title':true, [titleFancyPosition]: true}" v-if="titleFancy"><span class="title-text" v-html="titleFancy" :style="titleStyle" /></span>
	</div>

</template>

<script>
export default {
  name: 'Icon',
  props: {
   	type: {
      type: String,
      required: true
    },
	colour: {
	  type: String,
	  default: '#3b445b'
	},
	title: {
		type: String,
		default: ''
	},
	titleFancy: {
		type: String,
		default: ''
	},
	titleFancyPosition: {
		type: String,
		default: 'right'
	}
  },
  data() {
  	return {
		type2: ''
  	}
  },
  computed: {

	titleStyle () {

		let s = {};

		s.backgroundColor = this.colour;
		s.color = '#fff';
		s.borderColor = '#fff';

		return s;

	},

	color () {
		
		return this.colour || '#3b445b';

	},

	classes () {

      let c = {};

      return c;

    },

	theType () {

	  return this.type2 || this.type;

	},

	iconType () {

	  switch ( this.theType ) {

		case 'content-keywords':
		case 'contentKeywords':
		case 'content-and-keywords':

			return 'mag';

		case 'rank-tracking':
		case 'rankTracking':

			return 'graph';

		case 'data-dive':
		case 'dataDive':

			return 'bolt';

		case 'weekly-insights':
		case 'weeklyInsights':
		case 'insights':

			return 'bulb';

		case 'investigate':
		case 'investigation':
		case 'investigations':

			return 'search';

		case 'alerts':
		case 'alert':

			return 'bell';

		case 'keywordsUpDown':
		case 'keywords':

			return 'key';

		case 'users':

			return 'cog';

		case 'admin':

			return 'tools';

		case 'show-menu':

			return 'exchange-alt';

		case 'longtail-keywords':

				return 'long-tail-keywords';

		case 'high-bounce' :

			return 'high-bounce-rate';

		case 'low-traffic-high-impr' :

			return 'low-traffic-high-impressions';

		case 'content-improve' :

			return 'content-improvements';

		case 'hi-imp-low-ctr' :

			return 'high-impressions-low-ctr';

		case 'page-climbs' :

			return 'climbs';

		case 'page-drops' :

			return 'drops';

		case 'rank-lo-ctr' :

			return 'ctr-boost';

		case 'low-hanging-keyword' :
		case 'low-hanging-url' :

			return 'low-hanging-fruit';

		case 'warning' :

			return 'fa-triangle-exclamation';

		case 'pause' :

			return 'pause-circle';

		case 'ai_overview' :

			return 'ai';

		case 'brands' :

			return 'gifts';
		
		case 'delete' :

			return 'trash-can';

		case 'settings' :

			return 'gear';

		case 'upload-file' :

			return 'file-arrow-up';

		case 'csv' :

			return 'file-csv';

		case 'report-metrics' :

			return 'arrow-up-1-9';

		case 'report-cover' :

			return 'image';

		case 'report-graph' :

			return 'chart-line';

		case 'report-table' :

			return 'table';

		case 'report-text' :

			return 'font';

		case 'report-page' :

			return 'file-circle-plus';

	  }

	  return this.theType;

	},
	iconInfo () {

		let img = { type: '', src: '', byHeight: false };

		switch ( this.iconType ) {

			case 'exchange-alt' :
			case 'fa-triangle-exclamation' :
			case 'bell' :
			case 'tools' :
			case 'gifts' :
			case 'trash-can' :
			case 'copy' :
			case 'gear' :
			case 'up-down' :
			case 'file-arrow-up' :
			case 'file-csv' :
			case 'arrow-up-1-9' :
			case 'image' :
			case 'chart-line' :
			case 'table' :
			case 'list-ul' :
			case 'file-circle-plus' :
			case 'font' :
				img.type = 'fa';
				img.icon = this.iconType;

			break;

			case 'cog' :

				img.type = 'fa';
				img.icon = 'users-cog';

			break;

			case 'ai' :

				img.type = 'svg';
				img.viewBox = '0 0 600 600';
				img.src = '<g id="Page-1"><g id="icon"><path id="Combined-Shape" class="cls-1" style="fill:'+this.colour+';fill-rule:evenodd;stroke-width:0px;" d="M500,100v400H100V100h400ZM268.36,200h-38.96l-73.96,200h35.14l13.96-39.1h88.53l13.66,39.1h37.26l-75.65-200ZM406.4,200h-35v200h35v-200ZM248.59,233.56l34.87,99.78h-69.18l34.31-99.78ZM533.33,400h66.67v66.67h-66.67v-66.67ZM133.33,533.33h66.67v66.67h-66.67v-66.67ZM266.67,533.33h66.67v66.67h-66.67v-66.67ZM133.33,0h66.67v66.67h-66.67V0ZM400,533.33h66.67v66.67h-66.67v-66.67ZM266.67,0h66.67v66.67h-66.67V0ZM400,0h66.67v66.67h-66.67V0ZM533.33,266.67h66.67v66.67h-66.67v-66.67ZM0,400h66.67v66.67H0v-66.67ZM533.33,133.33h66.67v66.67h-66.67v-66.67ZM0,266.67h66.67v66.67H0v-66.67ZM0,133.33h66.67v66.67H0v-66.67Z"/></g></g>';

			break;

			case 'reports' :

				img.type = 'svg';
				img.viewBox = '0 0 41.38 49.49';
				img.src = '<path class="cls-1" style="fill:'+this.colour+';stroke-width:0px;" d="M4.68,49.49c-2.59,0-4.68-2.1-4.68-4.68V8.74c0-2.59,2.1-4.68,4.68-4.68h5.46v-1.62c0-1.35,1.09-2.44,2.44-2.44h16.22c1.35,0,2.44,1.09,2.44,2.44v1.62h5.46c2.59,0,4.68,2.1,4.68,4.68v36.07c0,2.59-2.1,4.68-4.68,4.68H4.68ZM36.49,42.37V11.18c0-1.24-1-2.24-2.24-2.24h-3.02v1.62c0,1.35-1.09,2.44-2.44,2.44H12.57c-1.35,0-2.44-1.09-2.44-2.44v-1.62h-3.02c-1.24,0-2.24,1-2.24,2.24v31.19c0,1.24,1,2.24,2.24,2.24h27.13c1.24,0,2.24-1,2.24-2.24h0ZM26.35,8.12v-3.23h-11.34v3.23h11.34Z"/><path class="cls-1" d="M12.57,39.36c-1.35,0-2.44-1.09-2.44-2.44v-8.11c0-1.35,1.09-2.44,2.44-2.44s2.44,1.09,2.44,2.44v8.11c0,1.35-1.09,2.44-2.44,2.44Z"/><path class="cls-1" d="M20.68,39.36c-1.35,0-2.44-1.09-2.44-2.44v-16.22c0-1.35,1.09-2.44,2.44-2.44s2.44,1.09,2.44,2.44v16.22c0,1.35-1.09,2.44-2.44,2.44Z"/><path class="cls-1" d="M28.79,39.36c-1.35,0-2.44-1.09-2.44-2.44v-12.17c0-1.35,1.09-2.44,2.44-2.44s2.44,1.09,2.44,2.44v12.17c0,1.35-1.09,2.44-2.44,2.44Z"/>';

			break;

			case 'projects' :

				img.type = 'fa';
				img.icon = 'project-diagram';

			break;

			case 'pause-circle' :

				img.type = 'fa';
				img.icon = 'pause-circle';

			break;

			case 'mag' :

				img.type = 'img';
				img.src = require('../../assets/img/mag-glass-key.svg');

			break;

			case 'key' :

				img.type = 'img';
				img.src = require('../../assets/img/icon-key.svg');

			break;

			case 'graph' :

				img.type = 'img';
				img.src = require('../../assets/img/graph.svg');

			break;

			case 'ring-spin' :

				img.type = 'img';
				img.src = require('../../assets/img/ring-spin.svg');

			break;

			case 'coffee-biscuit' :

				img.type = 'img';
				img.src = require('../../assets/img/coffee-biscuit.svg');

			break;

			case 'bolt' :

				img.type = 'fa';
				img.icon = 'bolt';
				img.byHeight = true;

			break;

			case 'bulb' :

				//img.type = 'fa';
				//img.icon = 'lightbulb';
				img.type = 'img';
				img.src = require('../../assets/img/bulb.svg');

			break;

			case 'search' :

				img.type = 'fa';
				img.icon = 'search';

			break;

			case 'video-youtube' :

				img.type = 'svg';
				img.src = '<path style="fill:'+this.colour+';" class="st" d="M99.72,6.1H19.38c-7.23,0-13.11,5.88-13.11,13.11v56.74c0,7.23,5.88,13.11,13.11,13.11h80.33c7.23,0,13.11-5.88,13.11-13.11V19.21C112.82,11.98,106.94,6.1,99.72,6.1z M47.64,63.46V31.69l25.74,15.89L47.64,63.46z"/>';
				img.viewBox = '0 0 117.1 95.15';

			break;

			default:

				let featureIcon = this.featureIconConvert ();

				if ( featureIcon ) {

					img.type = 'fa';
					img.icon = featureIcon.icon;

				}

		}

		if ( !img.type ) {

			img.type = 'img';
			img.src = require('../../assets/img/icon-'+this.iconType+'.svg');

		}

		return img;

	}

  },
  methods: {

    clicked() {

      this.$emit('clicked');

    },
	featureIconConvert () {

		switch ( this.iconType ) {

			case 'paid' : return { icon: 'dollar-sign', label: 'Paid' };
			case 'answer_box' : return { icon: 'align-left', label: 'Answer Box' };
			case 'local_pack' :  return { icon: 'map-marker-alt', label: 'Local Pack' };
			case 'knowledge_graph' : return { icon: 'brain', label: 'Knowledge Graph' };
			case 'featured_snippet' : return { icon: 'quote-right', label: 'Featured Snippet' };
			case 'top_stories' : return { icon: 'newspaper', label: 'Top Stories' };
			case 'map' : return { icon: 'map', label: 'Map' };
			case 'google_flights' : return { icon: 'plane-departure', label: 'Flights' };
			case 'images' : return { icon: 'images', label: 'Images', solid: false };
			case 'shopping' : return { icon: 'shopping-basket', label: 'Shopping' };
			case 'jobs' : return { icon: 'briefcase', label: 'Jobs' };
			case 'events' : return { icon: 'calendar-check', label: 'Events', solid: false };
			case 'mention_carousel' : return { icon: 'portrait', label: 'Mention Carousel' };
			case 'multi_carousel' : return { icon: 'portrait', label: 'Mention Carousel' };
			case 'recipes' : return { icon: 'utensils', label: 'Recipes' };
			case 'top_sights' : return { icon: 'mountain', label: 'Top Sights' };
			case 'scholarly_articles' : return { icon: 'book', label: 'Scholarly Articles' };
			case 'popular_products' : return { icon: 'fire-alt', label: 'Popular Products' };
			case 'podcasts' : return { icon: 'microphone-alt', label: 'Podcasts' };
			case 'multi_carousel' : return { icon: 'portrait', label: 'Multi Carousel' };
			case 'carousel' : return { icon: 'portrait', label: 'Carousel' };
			case 'google_reviews' : return { icon: 'star-half-alt', label: 'Reviews' };
			case 'google_posts' : return { icon: 'pencil-alt', label: 'Posts' };
			case 'hotels_pack' : return { icon: 'hotel', label: 'Hotels Pack' };
			case 'people_also_ask' : return { icon: 'question-circle', label: 'People Also Ask' };
			case 'related_searches' : return { icon: 'angle-double-right', label: 'Related Searches' };
			case 'people_also_search' : return { icon: 'copy', label: 'People Also Search' };
			case 'twitter' : return { icon: ['fab','twitter'], label: 'Twitter' };
			case 'video' : return { icon: 'video', label: 'Video' };
			case 'questions_and_answers' : return { icon: 'question', label: 'Questions And Answers' };
			case 'find_results_on' : return { icon: ['fab','searchengin'], label: 'Find Results On', solid: false };
			case 'stocks_box' : return { icon: 'chart-line', label: 'Stocks Box' };
			case 'visual_stories' : return { icon: 'eye', label: 'Visual Stories', solid: false };
			case 'commercial_units' : return { icon: 'warehouse', label: 'Commercial Units' };
			case 'local_services' : return { icon: 'wrench', label: 'Local Services' };
			case 'google_hotels' : return { icon: 'hotel', label: 'Hotels' };
			case 'short_videos' : return { icon: 'video', label: 'Short Videos' };
			case 'explore_brands' : return { icon: 'gifts', label: 'Explore Brands' };

		}

		return null;

	},

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.icon {

	width: 100%;
	display: inline-block;
	vertical-align: middle;
	position: relative;

	.title {

		position: absolute;
		top: 0;
		left: 100%;
		display: none;
		font-size: 12px;
		z-index: 10;
		padding: 0 0 0 10%;

		&.left {
			left: auto;
			right: 110%;
		}

		.title-text {

			display: inline-block;
			padding: 2px 5px;
			white-space: pre;
			border-radius: 2px;
			border: 1px solid #fff;
		}

	}

	&:hover {

		.title {

			display: block;

		}

	}

	svg, .svg {

		width: 100%;
		height: 100%;
		display: block;

	}

	&.colour {

		&.default-white-hover {

			svg, .svg {

				color: @formDefaultColour;

				&:hover {

					color: #fff;

				}

			}

		}

	}
	
}
</style>